import React from 'react'
import { useHistory } from 'react-router';
import CustomButton from '../shared/customButton/CustomButton';
import heroImage from './../assets/images/heroImage3.webp';
import './eurailPassPage.scss';
import { useAppDispatch } from '../redux/hooks';
import { setSelectedSearchBoxTab } from '../redux/actions/homeActions';
import {Helmet} from "react-helmet-async";

const questions = [
  {
    question: 'Where can I travel with a Eurail Pass?',
    answer: <p>You can travel between 40,000 destinations across 33 European countries. The pass can be used on the national railways and some private railways including the Eurostar, Thalys, TGV and AVE.</p>
  },
  {
    question: 'How do I buy a Eurail Pass?',
    answer: <p>You can <a href="/">buy your Eurail Pass on our website</a>. Rail Online is an accredited partner of Eurail</p>
  },
  {
    question: 'What info do I need to provide to book a Eurail Pass?',
    answer: <p>You need to provide three things – the European city where your adventure will begin, your trip’s start date and estimated end date, and the number of travellers. Based on this information, you will be provided with the best Eurail Pass option.</p>
  },
  {
    question: 'Should I buy a Eurail Global Pass or a Eurail Single County Pass?',
    answer: <p>If you plan to explore multiple European countries, the Global Pass is your best option. If you plan to explore one country (e.g. spend most of your trip in Italy or France), a Single Country Pass is your best option.</p>
  },
  {
    question: 'Once I’ve bought my pass, do I need to reserve a seat?',
    answer: <p>When you plan your route, you can check whether you need to reserve a seat or not. If you do need to reserve a seat. Popular trains like the Eurostar, Thalys, TGV and AVE require you to reserve a seat in advance.</p>
  },
  {
    question: 'Does Eurail offer discounts?',
    answer: <p>Yes. Children under 12 can travel for free on a Eurail Child Pass. Travellers aged 12 to 27 can order a Eurail Youth Pass and save 25% on standard adult prices. Travellers aged 60 and over can get a 10% senior discount on all Eurail Passes.</p>
  },
  {
    question: 'What should I do if I lose my Eurail Pass?',
    answer: <p>If you purchased a mobile pass, go to <a href="/myBookings">My Bookings</a> on our website to download it. If you have any trouble, contact our customer support team on <a href="mailTo:info@rail.online">info@rail.online</a></p>
  },
  {
    question: 'What is the difference between a train ticket and a rail pass?',
    answer: <p>A train ticket is for a single journey between two locations. The ticket is valid for a specific train on a specific date at a specific time. A rail pass, like the Eurail Pass, allows you to travel across a defined geographical area and can include multiple countries. You can travel across that area as much as you like during a set time frame.</p>
  },
]

function EurailPassPage() {
  const history = useHistory();
  const dispatch = useAppDispatch();

  return (
    <>
     <Helmet>
     <title>Rail Online - Buy Cheap Train Tickets in UK & Europe Online</title>
        <meta name="description" content="Rail Online is a quick & easy way to book cheap train tickets across UK & Europe. Take the scenic route with terrific deals on train tickets." />
          <link rel="canonical" href="https://www.rail.online/eurail-pass"/>
        </Helmet>
      <div className="hero-image-container">
        <div className="background-shade d-none d-md-flex opacity-change"></div>
        <img className="img-fluid hero-image d-none d-md-flex" src={heroImage} alt="heroImage" />
        <div className="about-us-page--title">
          <h1>Eurail Pass</h1>
          <h2>The all-in-one train ticket that gives you freedom and flexibility.</h2>
        </div>
      </div>
      <div className="container-fluid max-width mb-5">
        <div className="common-page">
          <div className="common-page--content-area max-width about-us-page">
            <p>
              A Eurail Pass is an all-in-one ticket that allows you to travel across 33 European countries in a simple and spontaneous way. Buy and activate your pass then simply hop on board and enjoy the ride. Some trains might ask you to make a reservation but most can be boarded by simply scanning your pass. With a Eurail Pass in your pocket, you can see Europe, your way. Love a particular destination? Stay a little longer. Ready to move on? Hop on board the next service. You’re in charge of your adventure. You get to create your ultimate itinerary.
            </p>

            <h3 className="mt-5 mb-3 text-left">Frequently Asked Questions</h3>

            {
              questions.map(({ question, answer }) => (
                <div key={question} className="qa-box">
                  <div className="qa-box--header">
                    <h4 className="p-2 p-md-3 pt-3 pb-3">{question}</h4>
                  </div>
                  <div className="p-2 p-md-3">{answer}</div>
                </div>
              ))
            }

            <h3 className="mt-5 mb-4">Ready to start your European adventure?</h3>
            <div className="d-flex w-100 justify-content-center">
              <CustomButton
                text="BOOK A EURAIL PASS"
                className="go-btn"
                onClick={() => {
                  dispatch(setSelectedSearchBoxTab('Eurail Pass'));
                  history.push('/book-eurail-pass')
                }} />
            </div>
          </div>
        </div>
        {/* this.props.history.replace({ pathname: `/product/${this.props.product.id}`}) */}

      </div>
    </>
  )
}

export default EurailPassPage
